import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.search";
/* eslint-disable */
/*价格说明-其它组件
 * <component-commission-description :promoter="promoter" :visible.sync="showCommissionDescription"></component-commission-description>
 */
import { isYKZApp, isYkzMiniprogram, isYkzAlipayMiniprogram, isOtherBrowsers } from '@ykz/ykz-util/platform';
export default {
  name: 'appDownload',
  data: function data() {
    return {
      isFxb: getUrlParams('fxbInviteCode') || '',
      weChatId: getUrlParams('weChatId') || window.weChatId,
      isAPP: isYKZApp(),
      //是否在云客赞app打开页面
      isOther: getUrlParams('isOther') || '',
      //非云客公众号直接通过链接访问所带的参数，用来隐藏二维码
      orderNo: getUrlParams('orderNo') || '',
      //订单号
      isMini: isYkzMiniprogram(),
      //是否在微信小程序打开页面
      isAlipayMini: isYkzAlipayMiniprogram(),
      // 是否在支付宝小程序内打开
      isOtherBrowser: isOtherBrowsers(),
      //除微信、app外的第三方浏览器打开页面
      isShop: sessionStorage.getItem('session_isShop') || '',
      //店铺模式
      hideOtherInfo: location.href.search('front/platform/platformFeature') != -1,
      //隐藏其它模块
      priceFolded: false,
      //价格说明模块是否已折叠
      priceExpandHeight: 0 //价格说明模块展开的高度
    };
  },

  props: {
    wxQrCode: {},
    goHomePage: {}
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    console.log('ycf组件初始化：price_other');
    window.componentCenter.priceOther = this;
    this.priceExpandHeight = $('.component-price-other .price-intro').innerHeight();
    this.priceFolded = true;
  },
  methods: {
    //展开价格说明模块
    expandPriceInfo: function expandPriceInfo() {
      this.priceFolded = false;
      $('.component-price-other .price-intro').css('height', this.priceExpandHeight);
    },
    //查看订单
    goOrderlist: function goOrderlist(event_id) {
      var _this = this;
      this.reportUserAnchors(event_id, function () {
        window.location.href = '/front/userCenter/orderlist?weChatId=' + _this.weChatId;
      });
    },
    //跳转到安全手册页
    goSafetyManualPage: function goSafetyManualPage() {
      window.location.href = '/front/platform/safetyManual';
    },
    //大数据锚点
    reportUserAnchors: function reportUserAnchors(event_id, callback) {
      YCF_Plugin.reportUserAnchors({
        event_id: event_id,
        event_content: {
          item_id: getUrlParams('goodId') || ''
        }
      }).always(callback);
    }
  }
};